import { Icon } from '@iconify/react';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import twitterFill from '@iconify/icons-eva/twitter-fill';
// import instagramFill from '@iconify/icons-eva/instagram-fill';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Grid, Divider, Container, Typography, IconButton, Stack, Button, Box } from '@material-ui/core';
import Logo from '../../Images/NavbarLogo.png'
import { ArrowForwardIos } from '@material-ui/icons';
import { AvTimer } from '@material-ui/icons';
import flashFill from '@iconify/icons-eva/flash-fill'
import { Link } from 'react-router-dom';

const SOCIALS = [
  { name: 'Google', icon: 'formkit--google' },
  { name: 'FaceBook', icon: 'bi--facebook' },
  { name: 'Twitter', icon: 'mdi--twitter' },
  { name: 'Telegram', icon: 'simple-icons--telegram' },
  { name: 'Linkedin', icon: 'streamline--linkedin-solid' },
  { name: 'Instagram', icon: 'grommet-icons--instagram', link: 'https://www.instagram.com/signwisesoftware?igsh=bGdobzI5d3ppMGk2' }
];

const Links = [
  { title: 'Features', icon: 'formkit--google', link: '/' },
  { title: 'Solutions', icon: 'bi--facebook', link: '/solutions' },
  { title: 'Tools', icon: 'mdi--twitter', link: '/tools' },
  { title: 'Industries', icon: 'mdi--twitter', link: '/industries' },
];

const LinksContact = [
  { title: 'Email', icon: 'line-md--email-twotone', link: 'mailto:info@signwise.com',content:"info@signwise.com" },
  { title: 'Phone', icon: 'line-md--phone-call-loop', link: 'tel:+18888519473',content:"+18888519473"  },
  { title: 'Booth', icon: 'fa-solid--person-booth', link: '/',content:"4766" },
];

const RootStyle = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  // padding: theme.spacing(10, 0),
  // paddingTop: '10px'
}));

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 5 }}>
        <Stack
          direction="column"
          justifyContent="center"
        >
          <Typography variant="h4" align="center" sx={{ mb: 2 }}>
            Let's Get to Work
          </Typography>
          <Typography variant="subtitle1" align="center" sx={{ mb: 3 }}>
            You've got big things to build. We've got the tools to help you move faster, smarter, and with way less friction.
          </Typography>
          <Container sx={{ pl: { xs: 8, md: 25 }, pr: { xs: 0, md: 25 }, }}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={8} justifyContent={{ xs: "flex-start", md: "center" }} sx={{ pb: 4 }}>
              <Stack direction="column" spacing={2} alignContent={'flex-start'} justifyContent={'flex-start'}>
                <Typography variant='h6'>Quick Links</Typography>
                {Links.map((link) => (<Stack direction="row" spacing={1} alignItems={"flex-start"} justifyContent={"flex-start"}>
                  {/* <Stack className={link.icon} sx={{ fontSize: 22, color: 'primary.main' }} /> */}
                  <a
                    href={link.link}
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'primary.main',
                        fontWeight: 500,
                        lineHeight: 1.2,
                        textDecoration: 'none',
                        fontSize: '16px',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      {link.title}
                    </Typography>
                  </a>
                </Stack>))}
              </Stack>
              <Stack direction="column" spacing={2} alignContent={'flex-start'} justifyContent={'flex-start'}>
                <Typography variant='h6'>Contact Us</Typography>
                {LinksContact.map((link) => (<Stack direction="row" spacing={1} alignItems={"flex-start"} justifyContent={"flex-start"}>
                  <Stack className={link.icon} sx={{ fontSize: 24, color: 'primary.main' }} />
                  
                    {
                      link.title =='Booth'?
                      <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 500, lineHeight: 1.2, color: 'primary.main', textAlign: 'center', fontSize: '16px' }}
                    >
                      {link.title}
                    </Typography>
                    :                  
                  <a href={link.link} style={{ textDecoration: 'none', fontSize: '16px'  }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 500, lineHeight: 1.2, color: 'primary.main', textAlign: 'center', fontSize: '16px' }}
                    >
                      {link.title}
                    </Typography>
                  </a>
                    }
                  {
                    link.title =='Booth'&&
                  
                  <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 500, lineHeight: 1.2, color: 'primary.main', textAlign: 'center', fontSize: '16px' }}
                    >
                      : {link.content}
                    </Typography>
                  }
                </Stack>))}
              </Stack>
            </Stack>
          </Container>
          <Box component={'div'} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, justifyContent: 'center', alignItems: 'center' }} align="center">
            <Link to={'/free-demo'} >
              <Button size='large' sx={{ boxShadow: 'none', borderRadius: '5px' }} startIcon={<Icon icon={flashFill} width={20} height={20} />} variant='contained'>Schedule Demo</Button>
            </Link>
            <Link to={'/free-demo'} >
              <Button size='large' sx={{ boxShadow: 'none', borderRadius: '5px' }} startIcon={<AvTimer />} variant='outlined'>Free 30 Minutes Consultation</Button>
            </Link>
          </Box>
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          sx={{ mt: 6, pl: { xs: 2, md: 0 } }}
        >
          {SOCIALS.map((social) => (
            <>
              <a key={social.name} href={social.link} target="_blank" rel="noopener noreferrer">
                <IconButton key={social.name} color="primary" sx={{
                  mr: 2, boxShadow: 'none', backgroundColor: 'rgb(35, 37, 42)', '.class': { color: 'rgb(99, 115, 129)' }, '&:hover': {
                    '.class': { color: 'primary.main' }, backgroundColor: 'common.white'
                  }
                }}>
                  <Stack className={`${social.icon} class`} sx={{ color: '#fff', fontSize: { xs: '1rem', sm: '1.8rem' } }} />

                </IconButton>
              </a>
            </>
          ))}
        </Stack>
      </Container>
      <Divider sx={{ mt: 6, }} />
      <Grid
        container
        justifyContent={{ xs: 'center', md: 'center' }}
        sx={{
          textAlign: 'center',
          // backgroundColor: '#0b0d1f',
          pl: { xs: 3, sm: 3, md: 6 },
          pr: { xs: 3, sm: 3, md: 6 },
        }}
      >
        <Grid item xs={12} md={12} sx={{ display: 'flex', flexDirection: "column", justifyContent: { xs: 'center', md: 'center' }, alignItems: 'center' }}>
          <Box component={'img'}
            src={Logo}
            sx={{
              width: 70, height: 70, mt: 2,
              mb: 1,
            }}
            alt={'Logo'}
          />
          <Stack direction="column">
            <Typography
              component="p"
              variant="h4"
              sx={{
                pb: 2,
                fontSize: 15,
                textAlign: { xs: 'center', md: 'center' },
              }}
            >
              Stay Updated
            </Typography>
            <Typography
              component="p"
              variant="subtitle1"
              sx={{
                pb: 2,
                fontSize: 15,
                textAlign: { xs: 'center', md: 'center' },
              }}
            >
              No fluff. No delays. Just results.
            </Typography>
            <Typography
              component="p"
              variant="subtitle2"
              sx={{
                pb: 2,
                fontSize: 15,
                textAlign: { xs: 'center', md: 'center' },
              }}
            >
              © 2024, Signwise Solutions Pvt. Ltd. All Rights Reserved.
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </RootStyle>
  );
}
